export default "__VITE_ASSET__CXqEV_gh__"